import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import base64 from 'base-64';

const LeaderComments = props => {
  let createExperience;
  let leaderCommentsLink;

  if (props.translations['create-experience']) {
    createExperience = props.translations['create-experience'].replace(
      '%{name}',
      props.firstName,
    );
    leaderCommentsLink = `${props.basePath}/${base64.encode(
      props.accountInfo,
    )}`;
  }

  // TODO:  #7 If NYP

  console.info('leader comments; STP:  ');
  console.info(props.invites.user.stp);
  console.info('leader comments; Program Type:  ');
  console.info(props.invites.program.type);

  if(props.invites.user.stp === '0001170328' && props.invites.program.type === 'Retirement') {
    createExperience = 'Please help create a personalized experience, this is your chance to honor %{name}. Your note can include examples of their great work, how they made an impact on the team or your favorite memory together.'.replace(/%{name}/g, props.invites.user.firstName);
  }

  return (
    /* eslint-disable jsx-a11y/anchor-is-valid */
    <div>
      <hr />
      <h1>{props.translations['add-leader-comments']}</h1>
      <p className="comment-proposal">{createExperience}</p>
      <Link
        id="write-comment"
        className="btn"
        style={{ backgroundColor: props.color }}
        to={`${leaderCommentsLink}`}
      >
        {props.translations['write-comment']}
      </Link>
    </div>
    /* eslint-enable jsx-a11y/anchor-is-valid */
  );
};

LeaderComments.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  color: PropTypes.string,
  firstName: PropTypes.string,
  accountInfo: PropTypes.string.isRequired,
  basePath: PropTypes.string.isRequired,
  invites: PropTypes.shape({
    people: PropTypes.string,
    autoInvites: PropTypes.array,
    sent: PropTypes.array,
    href: PropTypes.string,
    invite: PropTypes.shape({
      action: PropTypes.string,
    }),
    invite_v2: PropTypes.shape({
      action: PropTypes.string,
    }),
    invite_v3: PropTypes.shape({
      action: PropTypes.string,
    }),
    level: PropTypes.string,
    user: PropTypes.shape({
      firstName: PropTypes.string,
      name: PropTypes.string,
      stp: PropTypes.string,
    }),
    program: PropTypes.shape({
      type: PropTypes.string,
      color: PropTypes.string,
      restrictedEmails: PropTypes.array,
      peer: PropTypes.shape({
        image: PropTypes.shape({
          allowed: PropTypes.bool,
        }),
      }),
      manager: PropTypes.shape({
        image: PropTypes.shape({
          allowed: PropTypes.bool,
        }),
      }),
    }),
  }).isRequired,
};

LeaderComments.defaultProps = {
  color: '',
  firstName: '',
};

export default LeaderComments;
